export const fixtureCampaign = {
    campaignId: 1,
    type: 'Loyalty',
    voucher: {
      code: 'xxx10',
      autoApplies: false,
      startDate: '2023-01-01 00:00:00.000',
      expireDate: '2030-01-01 00:00:00.000',
    },
    description:
      "Complete [n] orders at [store(s)] and get a voucher for [DiscountPercentage|'a free meal']. Once the voucher is awarded it will expire after [y] days",
    requiredConditions: [
      {
        type: 'NumberOfOrdersPlaced',
        requiredValue: '10',
        description: 'Place 10 orders to be elegible',
        currentValue: '5',
      },
    ],
    rewards: [
      {
        type: 'TotalOrderAmountDiscountPercentage',
        value: '1',
        description: 'Free meal!',
        modifiers: [
          {
            type: 'CoverFees',
            value: 'true',
          },
          {
            type: 'CumulativeWithOtherCampaigns',
            value: 'false',
          },
        ],
      },
    ],
};